<template>
    <div class="flex align-cen total" :class="$util.isMobile() ? 'mobju' : ''">
        <img :src="businessInfo.logo || require('../../assets/images/blogo.png')" alt="" class="sider-head" v-if="!$util.isMobile()">
        <div class="topbar-icon flex algin-cen"  @click="$router.go(-1)" v-if="$util.isMobile() && $route.path != '/myExam/transcriptExam'" style="font-size:18px;color:#000">
               <i class="el-icon-arrow-left"></i> 
            </div>
            <div v-if="$route.path == '/myExam/transcriptExam'"></div>
             <div class="navigation-center" v-if="$util.isMobile()">
                {{$route.meta.title}}
                <!-- <img :src="logoimg ? logoimg :require('../../assets/images/HeroopSys.png')" alt="" class="sider-logo" > -->
                <!-- <img src="../../assets/images/HeroopSys.png" alt="" class="sider-logo"> -->
            </div>
        <div class="flex align-cen" v-if="$route.path !=`/myExam/${$route.name}`" :class="!$util.isMobile() ? 'mft' : ''">
                <el-dropdown>
                <span class="el-dropdown-link flex align-cen" >
                <img :src="userinfo.avatar || require('../../assets/images/head.png')" alt="" class="info-head">
                <span v-if="!$util.isMobile()">{{userinfo.name}}<i class="el-icon-arrow-down el-icon--right" ></i></span>
                 
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="switchHome"><i class="icon-al-home"></i> 返回官网</el-dropdown-item>
                    <el-dropdown-item @click.native="switchBuss"><i class="icon-al-switch"></i> 切换企业</el-dropdown-item>
                    <!-- <el-dropdown-item ><i class="icon-al-cog"></i> 个人设置</el-dropdown-item> -->
                    <el-dropdown-item   @click.native="logout1"><i class="icon-al-poweroff"></i>退出登录</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
        </div>
        <div v-if="$route.path ==`/myExam/${$route.name}`"> 
            
        </div>
    </div>
</template>
<script>
import {enBusiness} from "@/api/enterprise/index" //查询企业列表
    export default {
        name:'index',
        props: {
            type: [String, Number], //接口返回的点名
        },
        data() {
            return {
                userinfo:{},
                title:'',
                showDown:'',
                officialType:'',
            }
        },
        computed: {
        },
        created() {
            console.log(this.$route)
            // 获取本地存储用户信息
            this.userinfo = this.$locaStorage.setAge().get('userinfo1')
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
            this.officialType = this.$locaStorage.setAge().get('officialType')
            console.log(this.$route.path)
            // this.isType()
        },
        mounted() {},
        watch: {},
        methods: {
            isType(){
                const timekey = ["/myExam/examLogin","/myExam/doExam","/myExam/transcriptExam","/myExam/practiceExam"]
                timekey.forEach(t => {
                    if(this.$route.path == t){
                        this.showDown = 0
                   
                    }else{
                         this.showDown = 1
                    }
                  
                })
            },
            // 返回官网
            switchHome(){
                if(this.officialType == 1){
                    this.$router.push('/') 
                }else{
                    this.$router.push('/webenterpriseHlrj/homePage')
                }
                
            },
            //切换企业
            switchBuss(){
          enBusiness({},'enterprise')
            .then(res =>{
                if(res.code == 0){
                 if(res.data.length == 1){
                   this.$util.Notifi('当前只有一个主体公司，无法切换！','error','fa-exclamation-circle');
                }else{
                this.$router.push('/webenterprise/enBusiness')
                }
                }
            })
            },
            close(){
                window.close()
            },
           logout1(){
             localStorage.removeItem('token1')
            localStorage.removeItem('userinfo1')
             localStorage.removeItem('businessInfo')
             this.$router.push('/webenterprise/homePage')
            },
        },
        components: { 

         },
         
        destroyed(){
            // this.$bus.$off('titname')
        }
    }
</script>

<style scoped lang="scss">
.mobju{
    justify-content: space-between;
}
.navigation-center{
        width: calc(100% - 112px);
        text-align: center;
        img{
            width: 88px;
        }
    }
    .total{
        width: 100%;
          .sider-head{
            width: 120px;
            height: 40px;
        }
        .info-head{
            width: 30px;
            margin-right: 10px;
            height: 30px;
            border-radius: 50%;
        }
        .el-dropdown-link{
            color: #000;
            font-size: 16px;
            cursor: pointer;
        }
    }
</style>
